import React, { useState} from 'react';
import { Form, Button } from "react-bootstrap";
import { Icon } from '@iconify/react';
import sendOutlined from '@iconify-icons/ant-design/send-outlined';

import "./styles.scss";
import Anexos from '../../Anexos';


export default function Upload({setMensagemInput, recebeArquivo, enviarImagem, setOpenModalUpload, enviarArquivosLocais=false} ) {
    const [listaAnexos, setListaAnexos] = useState([]);
    const [filesTypes] = useState("*")

    const handleEnviarImagens  = () => {
        enviarImagem(enviarArquivosLocais ? listaAnexos : null);
        recebeArquivo(listaAnexos);
        setOpenModalUpload(false);
    }
    return <>
        <Form>
            <Anexos listaAnexos={listaAnexos} setListaAnexos={setListaAnexos} filesTypes={filesTypes} />
            <div className="area_btn_anexar">
                <Button className="anexarImagem" onClick={() => handleEnviarImagens()}>
                    Enviar <Icon icon={sendOutlined} color="white" />
                </Button>
            </div>
        </Form>
    </>
}
